export default "__VITE_ASSET__PB60Tq8M__"